<template>
  <div class="offset-sm-3 col-sm-6 col-10 offset-1" style="padding-bottom:100px;" v-if="this.occupations">
   <div class="form-group row">
    <div class="col-sm-12">
        <h3 class="mb-2">
         募集中の職種
        </h3>
        <h6>
            機能検証中のため、入力は当面不要です
        </h6>
        <div class="form-group row">
          <div class="col-md-12">
            <Alert type="danger" :messages="this.errors"/>
            <Alert type="success" :messages="this.messages"/>
            <div class="ps-4 mb-2" v-for="main in occupations" v-bind:key="main.id">
             <input
                type="checkbox"
                :id="main.id"
                :value="main.id"
                class="form-check-input"
                v-model="mainJobModel"

                @click="watchParentJobUncheck($event,'label'+main.id)"
              >
                 <label :id="'label'+main.id" @click="setLabelClicked" class="form-check-label job-label">{{main.title}}</label>
                    <div class="row" v-if="isChecked(main.id) ||isLabelClicked('label'+main.id)">
                        <div class="col-sm-6" v-for="child in main.children" v-bind:key="child._id">
                           <div class="form-check form-check-inline">
                            <input
                                type="checkbox"
                                :id="child._id"
                                :value="child._id"
                                class="form-check-input"
                                v-model="childJobModel"
                                @click="manuallyCheckJob($event,main)"
                            >
                            <label :for="child._id" class="form-check-label">{{child.title}}</label>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="btn-toolbar mt-5" role="toolbar" aria-label="Toolbar with button groups">
            <router-link to="/applicant" class="btn btn-outline-danger me-1">キャンセル</router-link>
            <button class="btn btn-primary" type="submit" @click.prevent="saveOccupation" :disabled="loading">
                変更を保存
            </button>
         </div>
        </div>
     </div>
    </div>
 </div>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import Alert from '@/components/utils/Alert.vue';
import ApiService from '@/service/apiService';
import Api from '@/config/api';
export default {
    name: 'OccupationList',
    components: { Alert },
    data(){
        return {
            clickedLabels:[],
            mainClicked:[],
            errors: [],
            messages: [],
            loading:false
        }
    },
    methods:{
        ...mapActions({loadSelectors: "occupation/loadSelectors", loadOccupation: 'occupation/loadCurrentCompanyOccupation'}),
        ...mapMutations({
            setChildJobModel: 'occupation/setChildJobModel',
            setMainJobModel:'occupation/setMainJobModel',
            updateMainJobModel: 'occupation/updateMainJobModel',
            setManuallyCheckedJobs: 'occupation/setManuallyCheckedJobs',
            setNewOccupation: 'occupation/setCurrentCompanyOccupation'
            }),
        async saveOccupation(){
            try{
                this.loading = true;
                this.messages = [];
                this.errors = [];
                let main = [...this.getMainJobModel, ...new Set(this.mainClicked)]
                // console.log(main);
                let params={
                    mainJobs: [...new Set(main)],
                    childOccupations: this.childJobModel
                };
                // console.log(params.mainJobs);
                let res = await ApiService.post(Api.endpoints.SET_OCCUPATION, params)
                if(res){
                    this.clearForm();
                    this.setNewOccupation(res.data.data.occupations);
                    // this.prepopulateModels();
                    this.messages.push('募集中の職種を設定しました');
                }
            }catch({response}){
                this.parseErrorResponse(response);
            }finally{
                this.loading = false;
            }
        },
        checkChildCount(main){
            let children = main.children.length;
            let childCount = 0;
            for(let i=0;i<main.children.length;i++){
                for(let j=0;j<this.childJobModel.length;j++){
                    // console.log('here');
                    if(main.children[i]._id == this.childJobModel[j]){
                        childCount++;
                    }
                }
            }
            let childCounts = {
                children,
                childCount
            }
            return childCounts;
        },
        // checkIndeterminate(main){
        //     let counts = this.checkChildCount(main);
        //     if(counts.childCount !=0){
        //         return true;
        //     }else {
        //         return false;
        //     }
        // },
        // checkAllChildrenChecked(main){
        //     let children = main.children.length;
        //     let childCount = 0;
        //     for(let i=0;i<main.children.length;i++){
        //         for(let j=0;j<this.childJobModel.length;j++){
        //             // console.log('here');
        //             if(main.children[i]._id == this.childJobModel[j]){
        //                 childCount++;
        //             }
        //         }
        //     }
        //     if(children == childCount){
        //         // console.log('here');
        //         this.mainJobModel.push(main.id);
        //         return true;
        //     }
        // },
        load(){
           this.loadSelectors();
           this.loadOccupation();
        },
        setLabelClicked(e){
            let index = this.clickedLabels.indexOf(e.target.id);
            if( index !== -1){
                this.clickedLabels.splice(index,1);
            }else{
                this.clickedLabels.push(e.target.id);
            }
        },
        isLabelClicked(id){
            return this.clickedLabels.indexOf(id) !== -1;
        },
        isClicked(id){
            if(this.clickedLabels.indexOf(id)!==-1){
                return 'fa fa-minus'
            }else{
                return 'fa fa-plus'
            }
        },
        isChecked(id) {
            if (this.mainJobModel.indexOf(id) !== -1) return true;
            return false;
        },
        watchParentJobUncheck(event, id){
            let index = this.clickedLabels.indexOf(id);
            let mainIndexId = id.replace('label','');
            let mainIndex = this.mainClicked.indexOf(mainIndexId);
            if(!event.target.checked && index !== -1){
                this.clickedLabels.splice(index,1);
            }
            if(!event.target.checked && mainIndex !== -1){
                let removed = this.mainClicked.filter((item)=> item != mainIndexId);
                this.mainClicked = [...removed]
            }
        },
        manuallyCheckJob(event,main){
            if(event.target.checked){
                this.manuallyCheckedJobs.push(event.target.id)
                this.mainClicked.push(main.id);
            }
            else{
                let index = this.manuallyCheckedJobs.indexOf(event.target.id);
                let mainIndex = this.mainClicked.indexOf(main.id);
                if(index !== -1){
                    this.manuallyCheckedJobs.splice(index,1);
                    this.mainClicked.splice(mainIndex,1);
                }
            }
            let x = this.checkChildCount(main);
            if(x.childCount <= 1){
                let mainJob = this.mainJobModel.indexOf(main.id);
                // let mainIndex = this.mainClicked.indexOf(main.id);
                if(mainJob !== -1){
                    this.mainJobModel.splice(mainJob,1);
                }
                // if(mainIndex !== -1){
                //     let removed = this.mainClicked.filter((item)=> item != main.id);
                //     this.mainClicked = [...removed]
                // }
            }
        },
        prepopulateModels(){
            this.childJobModel = this.companyOccupation.childOccupations ? this.companyOccupation.childOccupations : this.childJobModel;
            // this.mainJobModel = this.companyOccupation.mainJobs ? this.companyOccupation.mainJobs : this.childJobModel;
            this.companyOccupation.mainJobs && this.companyOccupation.mainJobs.forEach((item)=>{
                this.clickedLabels.push('label'+item);
            })
            // this.companyOccupation.mainJobs && this.companyOccupation.mainJobs.forEach((item)=>{
            //     this.mainClicked.push(item);
            // })
            if(this.companyOccupation.childOccupations){
                for(let i=0;i<this.occupations.length;i++){
                    for(let j=0;j<this.occupations[i].children.length;j++){
                        for(let k =0 ;k<this.companyOccupation.childOccupations.length;k++){
                            if(this.occupations[i].children[j]._id == this.companyOccupation.childOccupations[k]){
                                this.mainClicked.push(this.occupations[i].id);
                            }
                        }
                    }
                }
            }
            this.companyOccupation.childOccupations && this.setManuallyCheckedJobs(this.companyOccupation.childOccupations);
        },
        clearForm(){
            this.mainJobModel = []
            this.childJobModel = []
            this.setManuallyCheckedJobs([]);
            this.mainClicked=[];
            this.clickedLabels=[];
        }
    },
    computed:{
        ...mapState({
            occupations: (state) => state.occupation.selectors.occupations || [],
            manuallyCheckedJobs: (state) => state.occupation.manuallyCheckedJobs,
            companyOccupation: (state)=> state.occupation.currentCompanyOccupation,
        }),
        ...mapGetters({
            getChildJobModel: 'occupation/getChildJobModel',
            getMainJobModel: 'occupation/getMainJobModel',
            user: 'getCurrentUser',
        }),
        mainJobModel: {
            get() {
                return this.getMainJobModel;
            },
            set(value) {
                this.setMainJobModel(value);
            },
        },
        childJobModel: {
            get() {
                return this.getChildJobModel;
            },
            set(value) {
                this.setChildJobModel(value);
            },
        },
    },
    watch:{
        mainJobModel(mainJobs) {
          this.updateMainJobModel({mainJobs})
        },

        companyOccupation(value) {     
          this.prepopulateModels(); 
          if (Object.keys(value).length === 0) {
            this.clearForm();
          }
        },
    },
    created(){
        this.load();
        this.prepopulateModels();
    }
}
</script>

<style>

</style>